import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PartnerPlanDocumentDisplayForm from 'views/PartnerReports/PartnerPlan/PartnerPlanDocumentDisplayForm'

class PartnerPlanDocumentForm extends Component {
    static propTypes = {
      id: PropTypes.string,
    }

  static defaultProps = {
    id: 'partnerPlanDocumentForm',
  }

  render() {
    const {
      modals, currentUser, hide, forms, id, partnerPlan, selectedPlan,
    } = this.props
    return (
      <PartnerPlanDocumentDisplayForm
        currentUser={currentUser}
        description=""
        dispatch={this.props.dispatch}
        forms={forms}
        handleSubmit={this._submit}
        hide={hide}
        id={id}
        modals={modals}
        partnerPlan={partnerPlan}
        title={`${selectedPlan.Name} plan documents`}
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  modals: state.modals,
  partnerPlans: state.partnerPlans,
  partnerPlan: state.partnerPlan,
  selectedPlan: (Object.keys(state.partnerPlans.selectedPlan).length === 0 && sessionStorage.getItem('SelectedPlan') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPlan')) :
    state.partnerPlans.selectedPlan),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PartnerPlanDocumentForm))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlanDocumentForm.js